
export const HOSTING_STYLES = [
  "Casual",
  "Professional",
  "Family-friendly",
  "Adventure",
  "Cultural",
  "Luxury",
  "Budget-friendly",
  "Educational",
  "Eco-friendly",
  "Social"
];
